import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { UserService } from 'src/app/pages/user.service';



@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(
      public auth: UserService,
      public router: Router
  ) {
  }

  canActivate(): boolean {
    if (!this.auth.getToken()) {
      this.router.navigateByUrl('/login');
      return false;
    }
    return true;
  }

}
